
import login from '@/view/login/login.vue'
import login_jieyang from '@/view/login/login_jieyang.vue'

// import systemManagementMain from '@/components/systemManagementMain'

const Main = () => import('@/components/main')

/**
 * iview-admin中meta除了原生参数外可配置的参数:
 * meta: {
 *  title: { String|Number|Function }
 *         显示在侧边栏、面包屑和标签栏的文字
 *         使用'{{ 多语言字段 }}'形式结合多语言使用，例子看多语言的路由配置;
 *         可以传入一个回调函数，参数是当前路由对象，例子看动态路由和带参路由
 *  hideInBread: (false) 设为true后此级路由将不会出现在面包屑中，示例看QQ群路由配置
 *  hideInMenu: (false) 设为true后在左侧菜单不会显示该页面选项
 *  notCache: (false) 设为true后页面在切换标签后不会缓存，如果需要缓存，无需设置这个字段，而且需要设置页面组件name属性和路由配置的name一致
 *  access: (null) 可访问该页面的权限数组，当前路由设置的权限会影响子路由
 *  icon: (-) 该页面在左侧菜单、面包屑和标签导航处显示的图标，如果是自定义图标，需要在图标名称前加下划线'_'
 *  beforeCloseName: (-) 设置该字段，则在关闭当前tab页时会去'@/router/before-close.js'里寻找该字段名对应的方法，作为关闭前的钩子函数
 * }
 */

// 登录
export default [
  {
    path: '/login',
    name: 'login',
    meta: {
      title: 'Login - 登录',
      hideInMenu: true
    },
    component: (window.location.port == 38081 ? login_jieyang : login)
  },

  {
    path: '/project-page',
    name: 'project-page',
    meta: {
      title: '项目列表',
      hideInMenu: true
    },
    component: () => import('@/view/home/project-page/project-list.vue')
  },

  {
    path: '/',
    name: '/home-page',
    component: Main,
    meta: {
      // hideInMenu: true,
      notCache: true
    },

    redirect: '/home-page',
    children: [
      {
        path: 'home-page',
        name: 'home-page',
        meta: {
          icon: 'md-home',
          title: 'Dashboard',
        },
        component: () => import('@/view/Completion-home/home-page/home-page.vue')
      }

    ]
  },

  {
    path: '/Import',
    name: 'Import',
    component: Main,
    meta: {
      title: 'Imports',
      icon: 'md-cloud-upload'
    },
    children: [
      {
        path: 'Imports',
        name: 'Imports',
        meta: {
          title: 'Imports'
          // icon: 'ios-document',
        },
        component: () => import('@/view/Import/Imports.vue')
      },
      {
        path: 'Import_Logs',
        name: 'Import_Logs',
        meta: {
          title: 'Import_Logs'
          // //icon: 'md-clipboard',
        },
        component: () => import('@/view/Import/ImportResult.vue')
      },
      {
        path: 'ImportsDigitalDocument',
        name: 'ImportsDigitalDocument',
        meta: {
          title: 'ImportsDigitalDocument'
          // icon: 'ios-document',
        },
        component: () => import('@/view/Import/ImportsDigitalDocument.vue')
      }
    ]
  },

  // ref.table页面
  {
    path: '/RefTable',
    name: 'RefTable',
    meta: {
      icon: 'md-paper',
      // title: 'RefTable',
      title: 'Engineering'
    },
    component: Main,
    children: [
      {
        path: 'Activity',
        name: 'Activity',
        meta: {
          // icon: 'ios-document',
          title: 'Activity'
        },
        component: () => import('@/view/RefTable/Activity/Activity.vue')
      },
      {
        path: 'Area',
        name: 'Area',
        meta: {
          // //icon: 'md-clipboard',
          title: 'Area'
        },
        component: () => import('@/view/RefTable/Area/Area.vue')
      },
      {
        path: 'AuthorisedPerson',
        name: 'AuthorisedPerson',
        meta: {
          // icon: 'md-person',
          title: 'AuthorisedPerson'
        },
        component: () => import('@/view/RefTable/Authorised_Person/AuthorisedPerson.vue')
      },
      {
        path: 'AuthorisedPersonProfession',
        name: 'AuthorisedPersonProfession',
        meta: {
          // icon: 'md-person',
          title: 'AuthorisedPersonProfession'
        },
        component: () => import('@/view/RefTable/AuthorisedPersonProfession/AuthorisedPersonProfession.vue')
      },
      {
        path: 'AuthorisedPersonDiscipline',
        name: 'AuthorisedPersonDiscipline',
        meta: {
          // icon: 'md-person',
          title: 'AuthorisedPersonDiscipline'
        },
        component: () => import('@/view/RefTable/AuthorisedPersonDiscipline/AuthorisedPersonDiscipline.vue')
      },
      {
        path: 'AuthorisedPersonSubcontractorName',
        name: 'AuthorisedPersonSubcontractorName',
        meta: {
          // icon: 'md-person',
          title: 'AuthorisedPersonSubcontractorName'
        },
        component: () => import('@/view/RefTable/AuthorisedPersonSubcontractorName/AuthorisedPersonSubcontractorName.vue')
      },
      {
        path: 'AssuranceTracker',
        name: 'AssuranceTracker',
        meta: {
          // //icon: 'md-clipboard',
          title: 'AssuranceTracker',
          hideInMenu: true
        },
        component: () => import('@/view/RefTable/AssuranceTracker/AssuranceTracker.vue')
      },
      {
        path: 'AssuranceTrackerCompletionStatus',
        name: 'AssuranceTrackerCompletionStatus',
        meta: {
          // //icon: 'md-clipboard',
          title: 'AssuranceTrackerCompletionStatus',
          hideInMenu: true
        },
        component: () => import('@/view/RefTable/AssuranceTrackerCompletionStatus/AssuranceTrackerCompletionStatus.vue')
      },
      {
        path: 'ActionParty',
        name: 'ActionParty',
        meta: {
          // //icon: 'md-clipboard',
          title: 'ActionParty'
        },
        component: () => import('@/view/RefTable/ActionParty/ActionParty.vue')
      },
      {
        path: 'CableType',
        name: 'CableType',
        meta: {
          // //icon: 'md-clipboard',
          title: 'CableType'
        },
        component: () => import('@/view/RefTable/Cable-types/Cable-types.vue')
      },
      {
        path: 'DigitalDocumentCheckBoxType',
        name: 'DigitalDocumentCheckBoxType',
        meta: {
          // icon: 'md-clipboard',
          title: 'DigitalDocumentCheckBoxType'
        },
        component: () => import('@/view/RefTable/DigitalDocumentCheckBoxType/Digital.vue')
      },
      {
        path: 'Discipline',
        name: 'Discipline',
        meta: {
          // //icon: 'md-clipboard',
          title: 'Disciplines'
        },
        component: () => import('@/view/RefTable/Discipline/Discipline.vue')
      },
      {
        path: 'Drawing',
        name: 'Drawing',
        meta: {
          // //icon: 'md-clipboard',
          title: 'Drawing'
        },
        component: () => import('@/view/RefTable/Drawing/Drawing.vue')
      },
      {
        path: 'DrawingType',
        name: 'DrawingType',
        meta: {
          // //icon: 'md-clipboard',
          title: 'DrawingType'
        },
        component: () => import('@/view/RefTable/DrawingType/DrawingType.vue')
      },
      {
        path: 'DrawingStatus',
        name: 'DrawingStatus',
        meta: {
          // //icon: 'md-clipboard',
          title: 'DrawingStatus'
        },
        component: () => import('@/view/RefTable/DrawingStatus/DrawingStatus.vue')
      },
      {
        path: 'ExCertifyingbody',
        name: 'ExCertifyingbody',
        meta: {
          // //icon: 'md-clipboard',
          title: 'ExCertifyingbody'
        },
        component: () => import('@/view/RefTable/Ex_certifying_body/Ex_certifying_body.vue')
      },
      {
        path: 'ExIPRating',
        name: 'ExIPRating',
        meta: {
          // icon: 'md-clipboard',
          title: 'ExIPRating'
        },
        component: () => import('@/view/RefTable/Ex_ip_rating/ExIPRating.vue')
      },
      {
        path: 'ExProtection',
        name: 'ExProtection',
        meta: {
          // //icon: 'md-clipboard',
          title: 'ExProtection'
        },
        component: () => import('@/view/RefTable/ExProtection/ExProtection.vue')
      },
      {
        path: 'ExRatedModels',
        name: 'ExRatedModels',
        meta: {
          // //icon: 'md-clipboard',
          title: 'ExRatedModels'
        },
        component: () => import('@/view/RefTable/ExRatedModels/ExRatedModels.vue')
      },
      {
        path: 'ExRatedtoITR',
        name: 'ExRatedtoITR',
        meta: {
          // //icon: 'md-clipboard',
          title: 'ExRatedtoITR'
        },
        component: () => import('@/view/RefTable/ExRatedtoITR/ExRatedtoITR.vue')
      },
      {
        path: 'EquipmentType',
        name: 'EquipmentType',
        meta: {
          // //icon: 'md-clipboard',
          title: 'EquipmentType'
        },
        component: () => import('@/view/RefTable/Equipment-type/Equipment-type.vue')
      },
      {
        path: 'EquipmentStatus',
        name: 'EquipmentStatus',
        meta: {
          // //icon: 'md-clipboard',
          title: 'EquipmentStatus'
        },
        component: () => import('@/view/RefTable/Equipment-status/Equipment-status.vue')
      },
      {
        path: 'EquipmentTypeITR',
        name: 'EquipmentTypeITR',
        meta: {
          // //icon: 'md-clipboard',
          title: 'EquipmentTypeITR'
        },
        component: () => import('@/view/RefTable/Equipment-Type-to-ITR/Equipment-Type-to-ITR.vue')
      },
      {
        path: 'EquipmentTypePWL',
        name: 'EquipmentTypePWL',
        meta: {
          // //icon: 'md-clipboard',
          title: 'EquipmentTypePWL'
        },
        component: () => import('@/view/RefTable/Equipment-type-to-PWL/Equipment-type-to-PWL.vue')
      },
      {
        path: 'ExZones',
        name: 'ExZones',
        meta: {
          // //icon: 'md-clipboard',
          title: 'ExZones'
        },
        component: () => import('@/view/RefTable/ExZones/ExZones.vue')
      },
      {
        path: 'GlandTypes',
        name: 'GlandTypes',
        meta: {
          // //icon: 'md-clipboard',dover
          title: 'GlandTypes'
        },
        component: () => import('@/view/RefTable/GlandTypes/GlandTypes.vue')
      },
      {
        path: 'HandoverCompletionStatus',
        name: 'HandoverCompletionStatus',
        meta: {
          // //icon: 'md-clipboard',
          title: 'HandoverCompletionStatus'
        },
        component: () => import('@/view/RefTable/HandoverCompletionStatus/HandoverCompletionStatus.vue')
      },
      {
        path: 'HandoverType',
        name: 'HandoverType',
        meta: {
          // //icon: 'md-clipboard',
          title: 'HandoverTypes',
          hideInMenu: true
        },
        component: () => import('@/view/RefTable/Handovertype/Handovertype.vue')
      },
      {
        path: 'ITRs',
        name: 'ITRs',
        meta: {
          // //icon: 'md-clipboard',
          title: 'ITRs'
        },
        component: () => import('@/view/RefTable/ITRs/ITRs.vue')
      },
      {
        path: 'ITRclass',
        name: 'ITRclass',
        meta: {
          // //icon: 'md-clipboard',
          title: 'ITRClass'
        },
        component: () => import('@/view/RefTable/ITRclass/ITRclass.vue')
      },
      {
        path: 'JobCardDrawing',
        name: 'JobCardDrawing',
        meta: {
          // //icon: 'md-clipboard',
          title: 'JobCardDrawing',
          hideInMenu: true
        },
        component: () => import('@/view/RefTable/JobCardDrawing/JobCardDrawing.vue')
      },
      {
        path: 'JobCardStatus',
        name: 'JobCardStatus',
        meta: {
          // //icon: 'md-clipboard',
          title: 'JobCardStatus'
        },
        component: () => import('@/view/RefTable/JobCardStatus/JobCardStatus.vue')
      },
      {
        path: 'Location',
        name: 'Location',
        meta: {
          // //icon: 'md-clipboard',
          title: 'Location'
        },
        component: () => import('@/view/RefTable/Location/Location.vue')
      },
      {
        path: 'Loop',
        name: 'Loop',
        meta: {
          // //icon: 'md-clipboard',
          title: 'Loop'
        },
        component: () => import('@/view/RefTable/Loop/Loop.vue')
      },
      {
        path: 'Module',
        name: 'Module',
        meta: {
          // //icon: 'md-clipboard',
          title: 'Module'
        },
        component: () => import('@/view/RefTable/Module/Module.vue')
      },
      {
        path: 'NotificationGroup',
        name: 'NotificationGroup',
        meta: {
          // //icon: 'md-clipboard',
          title: 'NotificationGroup',
          hideInMenu: true
        },
        component: () => import('@/view/RefTable/NotificationGroup/NotificationGroup.vue')
      },
      {
        path: 'NotificationGroupAuthorisedPerson',
        name: 'NotificationGroupAuthorisedPerson',
        meta: {
          // //icon: 'md-clipboard',
          title: 'NotificationGroupAuthorisedPerson',
          hideInMenu: true
        },
        component: () => import('@/view/RefTable/NotificationGroupPerson/NotificationGroupPerson.vue')
      },
      {
        path: 'OperationType',
        name: 'OperationType',
        meta: {
          // //icon: 'md-clipboard',
          title: 'OperationType'
        },
        component: () => import('@/view/RefTable/OperationType/OperationType.vue')
      },
      {
        path: 'ORAPriority',
        name: 'ORAPriority',
        meta: {
          // //icon: 'md-clipboard',
          title: 'ORAPriority'
        },
        component: () => import('@/view/RefTable/ORAPriority/ORAPriority.vue')
      },
      {
        path: 'ParentTag',
        name: 'ParentTag',
        meta: {
          // //icon: 'md-clipboard',
          title: 'ParentTag'
        },
        component: () => import('@/view/RefTable/ParentTag/ParentTag.vue')
      },
      {
        path: 'Phase',
        name: 'Phase',
        meta: {
          // //icon: 'md-clipboard',
          title: 'Phase'
        },
        component: () => import('@/view/RefTable/Phase/Phase.vue')
      },
      {
        path: 'PreservationCompletionStatus',
        name: 'PreservationCompletionStatus',
        meta: {
          // //icon: 'md-clipboard',
          title: 'PreservationCompletionStatus'
        },
        component: () => import('@/view/RefTable/PreservationCompletionStatus/PreservationCompletionStatus.vue')
      },
      {
        path: 'Priority',
        name: 'Priority',
        meta: {
          // //icon: 'md-clipboard',
          title: 'Priority'
        },
        component: () => import('@/view/RefTable/Priority/Priority.vue')
      },
      {
        path: 'ProcedureType',
        name: 'ProcedureType',
        meta: {
          // //icon: 'md-clipboard',
          title: 'ProcedureType'
        },
        component: () => import('@/view/RefTable/ProcedureType/ProcedureType.vue')
      },
      {
        path: 'ProcedureCategory',
        name: 'ProcedureCategory',
        meta: {
          // //icon: 'md-clipboard',
          title: 'ProcedureCategory'
        },
        component: () => import('@/view/RefTable/ProcedureCategory/ProcedureCategory.vue')
      },
      {
        path: 'ProcedureClass',
        name: 'ProcedureClass',
        meta: {
          // //icon: 'md-clipboard',
          title: 'ProcedureClass'
        },
        component: () => import('@/view/RefTable/ProcedureClass/ProcedureClass.vue')
      },
      {
        path: 'ProcedureCompletionStatus',
        name: 'ProcedureCompletionStatus',
        meta: {
          // //icon: 'md-clipboard',
          title: 'ProcedureCompletionStatus'
        },
        component: () => import('@/view/RefTable/ProcedureCompletionStatus/ProcedureCompletionStatus.vue')
      },
      {
        path: 'ProcedureDocumentStatus',
        name: 'ProcedureDocumentStatus',
        meta: {
          // //icon: 'md-clipboard',
          title: 'ProcedureDocumentStatus'
        },
        component: () => import('@/view/RefTable/ProcedureDocumentStatus/ProcedureDocumentStatus.vue')
      },
      {
        path: 'Profession',
        name: 'Profession',
        meta: {
          // //icon: 'md-clipboard',
          title: 'Profession'
        },
        component: () => import('@/view/RefTable/Profession/Profession.vue')
      },
      {
        path: 'ProfessionDiscipline',
        name: 'ProfessionDiscipline',
        meta: {
          // //icon: 'md-clipboard',
          title: 'ProfessionDiscipline'
        },
        component: () => import('@/view/RefTable/ProfessionDiscipline/ProfessionDiscipline.vue')
      },
      {
        path: 'PunchListItemCategory',
        name: 'PunchListItemCategory',
        meta: {
          // //icon: 'md-clipboard',
          title: 'PunchListItemCategory'
        },
        component: () => import('@/view/RefTable/PunchListItemCategory/PunchListItemCategory.vue')
      },
      {
        path: 'PunchListItemCompletionStatus',
        name: 'PunchListItemCompletionStatus',
        meta: {
          // //icon: 'md-clipboard',
          title: 'PunchListItemCompletionStatus'
        },
        component: () => import('@/view/RefTable/PunchListItemCompletionStatus/PunchListItemCompletionStatus.vue')
      },
      {
        path: 'PWLs',
        name: 'PWLs',
        meta: {
          // //icon: 'md-clipboard',
          title: 'PreservationWorkList'
        },
        component: () => import('@/view/RefTable/PWLs/PWLs.vue')
      },
      {
        path: 'PWLAddEditDocument',
        name: 'PWLAddEditDocument',
        meta: {
          // icon: 'md-clipboard',
          title: 'PWLEditdigitaldocuments',
          hideInMenu: true
        },
        component: () => import('@/view/DigitalDocument/AddEditDocument/PWLAddEditDocument.vue')
      },
      {
        path: 'PWLPreviewDocument',
        name: 'PWLPreviewDocument',
        meta: {
          // icon: 'md-clipboard',
          title: 'PWLPreviewDocument',
          hideInMenu: true
        },
        component: () => import('@/view/DigitalDocument/AddEditDocument/PWLPreviewDocument.vue')
      },
      {
        path: 'PWLDownloadDocument',
        name: 'PWLDownloadDocument',
        meta: {
          // icon: 'md-clipboard',
          title: '下载数字文档',
          hideInMenu: true
        },
        component: () => import('@/view/DigitalDocument/AddEditDocument/PWLDownloadDocument.vue')
      },
      {
        path: 'ProcedureDrawing',
        name: 'ProcedureDrawing',
        meta: {
          // icon: 'md-clipboard',
          title: 'ProcedureDrawing'
        },
        component: () => import('@/view/RefTable/procedureDrawing/procedureDrawing.vue')
      },
      {
        path: 'ServiceDetail',
        name: 'ServiceDetail',
        meta: {
          // //icon: 'md-clipboard',
          title: 'PreservationDetail'
        },
        component: () => import('@/view/RefTable/ServiceDetail/ServiceDetail.vue')
      },
      {
        path: 'ServiceInterval',
        name: 'ServiceInterval',
        meta: {
          // //icon: 'md-clipboard',
          title: 'PreservationInterval'
        },
        component: () => import('@/view/RefTable/ServiceInterval/ServiceInterval.vue')
      },
      {
        path: 'System',
        name: 'System',
        meta: {
          // //icon: 'md-clipboard',
          title: 'System'
        },
        component: () => import('@/view/RefTable/System/System.vue')
      },
      {
        path: 'SubSystem',
        name: 'SubSystem',
        meta: {
          // //icon: 'md-clipboard',
          title: 'SubSystem'
        },
        component: () => import('@/view/RefTable/Subsystem/Subsystem.vue')
      },
      {
        path: 'SystemGroup',
        name: 'SystemGroup',
        meta: {
          // //icon: 'md-clipboard',
          title: 'SystemGroup'
        },
        component: () => import('@/view/RefTable/SystemGroup/SystemGroup.vue')
      },
      {
        path: 'Skill',
        name: 'Skill',
        meta: {
          // //icon: 'md-clipboard',
          title: 'Skill'
        },
        component: () => import('@/view/RefTable/Skill/Skill.vue')
      },
      {
        path: 'SubcontractorName',
        name: 'SubcontractorName',
        meta: {
          // //icon: 'md-clipboard',
          title: 'SubcontractorName'
        },
        component: () => import('@/view/RefTable/SubcontractorName/SubcontractorName.vue')
      },
      {
        path: 'TagITRCompletionStatus',
        name: 'TagITRCompletionStatus',
        meta: {
          // //icon: 'md-clipboard',
          title: 'TagITRCompletionStatus'
        },
        component: () => import('@/view/RefTable/TagITRCompletionStatus/TagITRCompletionStatus.vue')
      },
      {
        path: 'TestPackType',
        name: 'TestPackType',
        meta: {
          // //icon: 'md-clipboard',
          title: 'TestPackType'
        },
        component: () => import('@/view/RefTable/TestPackType/TestPackType.vue')
      },
      {
        path: 'TrackerCategory',
        name: 'TrackerCategory',
        meta: {
          // //icon: 'md-clipboard',
          title: 'TrackerCategory'
        },
        component: () => import('@/view/RefTable/TrackerCategory/TrackerCategory.vue')
      },
      {
        path: 'TrackerSubCategory',
        name: 'TrackerSubCategory',
        meta: {
          // //icon: 'md-clipboard',
          title: 'TrackerSubCategory'
        },
        component: () => import('@/view/RefTable/TrackerSubCategory/TrackerSubCategory.vue')
      },
      {
        path: 'TrackerType',
        name: 'TrackerType',
        meta: {
          // //icon: 'md-clipboard',
          title: 'TrackerType'
        },
        component: () => import('@/view/RefTable/TrackerType/TrackerType.vue')
      },
      {
        path: 'UnitsofMeasure',
        name: 'UnitsofMeasure',
        meta: {
          // //icon: 'md-clipboard',
          title: 'UnitsofMeasure'
        },
        component: () => import('@/view/RefTable/UnitsofMeasure/UnitsofMeasure.vue')
      },
      {
        path: 'Vendor',
        name: 'Vendor',
        meta: {
          // //icon: 'md-clipboard',
          title: 'Vendor'
        },
        component: () => import('@/view/RefTable/Vendor/Vendor.vue')
      },
      {
        path: 'WorkGroup',
        name: 'WorkGroup',
        meta: {
          // //icon: 'md-clipboard',
          title: 'WorkGroup'
        },
        component: () => import('@/view/RefTable/WorkGroup/WorkGroup.vue')
      },
      {
        path: 'WorkPackCompletionStatus',
        name: 'WorkPackCompletionStatus',
        meta: {
          // //icon: 'md-clipboard',
          title: 'WorkPackCompletionStatus'
        },
        component: () => import('@/view/RefTable/WorkPackCompletionStatus/WorkPackCompletionStatus.vue')
      },
      {
        path: 'WorkPackType',
        name: 'WorkPackType',
        meta: {
          // //icon: 'md-clipboard',
          title: 'WorkPackType'
        },
        component: () => import('@/view/RefTable/WorkPackType/WorkPackType.vue')
      },
      {
        path: 'AddEditDocument',
        name: 'AddEditDocument',
        meta: {
          // icon: 'md-clipboard',
          title: 'Editdigitaldocuments',
          hideInMenu: true
        },
        component: () => import('@/view/DigitalDocument/AddEditDocument/AddEditDocument.vue')
      },
      {
        path: 'PreviewDocument',
        name: 'PreviewDocument',
        meta: {
          // icon: 'md-clipboard',
          title: 'PreviewDocument',
          hideInMenu: true
        },
        component: () => import('@/view/DigitalDocument/AddEditDocument/PreviewDocument.vue')
      },
      {
        path: 'DownloadDocument',
        name: 'DownloadDocument',
        meta: {
          // icon: 'md-clipboard',
          title: '下载数字文档',
          hideInMenu: true
        },
        component: () => import('@/view/DigitalDocument/AddEditDocument/DownloadDocument.vue')
      },
      {
        path: 'Test',
        name: 'Test',
        meta: {
          // icon: 'md-clipboard',
          title: '测试数字文档',
          hideInMenu: true
        },
        component: () => import('@/view/DigitalDocument/AddEditDocument/Test.vue')
      },

      {
        path: 'TagItrDownloadDocument',
        name: 'TagItrDownloadDocument',
        meta: {
          // icon: 'md-clipboard',
          title: 'TagItr下载数字文档',
          hideInMenu: true
        },
        component: () => import('@/view/DigitalDocument/AddEditDocument/TagItrDownloadDocument.vue')
      },
      {
        path: 'DownloadDocumentCopy',
        name: 'DownloadDocumentCopy',
        meta: {
          // icon: 'md-clipboard',
          title: '下载数字文档Copy',
          hideInMenu: true
        },
        component: () => import('@/view/DigitalDocument/AddEditDocument/DownloadDocumentCopy.vue')
      },
      {
        path: 'DownloadDocumentExample',
        name: 'DownloadDocumentExample',
        meta: {
          // icon: 'md-clipboard',
          title: '下载数字文档示例',
          hideInMenu: true
        },
        component: () => import('@/view/DigitalDocument/AddEditDocument/DownloadDocumentExample.vue')
      },
      {
        path: 'HandoverAddEditDocument',
        name: 'HandoverAddEditDocument',
        meta: {
          // icon: 'md-clipboard',
          title: 'HandoverAddEditDocument',
          hideInMenu: false
        },
        component: () => import('@/view/DigitalDocument/HandoverAddEditDocument/HandoverAddEditDocument.vue')
      },
      {
        path: 'HandoverCCCAddEditDocument',
        name: 'HandoverCCCAddEditDocument',
        meta: {
          // icon: 'md-clipboard',
          title: 'HandoverCCCAddEditDocument',
          hideInMenu: true
        },
        component: () => import('@/view/DigitalDocument/HandoverAddEditDocument/HandoverCCCAddEditDocument.vue')
      },
      {
        path: 'HandoverPreviewDocument',
        name: 'HandoverPreviewDocument',
        meta: {
          // icon: 'md-clipboard',
          title: 'HandoverPreviewDocument',
          hideInMenu: true
        },
        component: () => import('@/view/DigitalDocument/HandoverAddEditDocument/HandoverPreviewDocument.vue')
      },
      {
        path: 'DownloadDocumentTest',
        name: 'DownloadDocumentTest',
        meta: {
          // icon: 'md-clipboard',
          title: 'DownloadDocumentTest',
          hideInMenu: true
        },
        component: () => import('@/view/DigitalDocument/AddEditDocument/DownloadDocumentTest.vue')
      }
      // {
      //   path: 'PreviewDocument',
      //   name: 'PreviewDocument',
      //   meta: {
      //     //icon: 'md-clipboard',
      //     title: 'wss测试'
      //   },
      //   component: () => import('@/view/DigitalDocument/PreviewDocument/preview.vue')
      // },
    ]
  },

  // Work Pack 工作包
  {
    path: '/WorkPack',
    name: 'WorkPack',
    meta: {
      icon: 'ios-basket-outline',
      title: 'WorkPack',
      hideInMenu: true
    },
    component: Main,
    children: [
      {
        path: 'WorkPacks',
        name: 'WorkPacks',
        meta: {
          // //icon: 'md-clipboard',
          title: 'WorkPack'
        },
        component: () => import('@/view/Work-pack/Work-pack/Workpack.vue')
      },
      {
        path: 'JobCard',
        name: 'JobCard',
        meta: {
          // //icon: 'md-clipboard',
          title: 'JobCard',
        },
        component: () => import('@/view/Work-pack/Job-card/Jobcard.vue')
      },
      {
        path: 'Operation',
        name: 'Operation',
        meta: {
          // //icon: 'md-clipboard',
          title: 'Operation',
        },
        component: () => import('@/view/Work-pack/Operation/Operation.vue')
      },
      {
        path: 'WorkPackGrid',
        name: 'WorkPackGrid',
        meta: {
          // //icon: 'md-clipboard',
          title: 'WorkPackGrid',
        },
        component: () => import('@/view/Work-pack/Work-pack-grid/Workpackgrid.vue')
      },
      {
        path: 'WorkPackSkyline',
        name: 'WorkPackSkyline',
        meta: {
          // //icon: 'md-clipboard',
          title: 'WorkPackSkyline',
        },
        component: () => import('@/view/Work-pack/Work-pack-skyline/WorkPackSkyline.vue')
      },
      {
        path: 'JobCardSkyline',
        name: 'JobCardSkyline',
        meta: {
          // //icon: 'md-clipboard',
          title: 'JobCardSkyline',
        },
        component: () => import('@/view/Work-pack/Job-card-skyline/JobCardSkyline.vue')
      },
      {
        path: 'PlannedVsActualProgressReport',
        name: 'JobCardPlannedvsActualProgress',
        meta: {
          // //icon: 'md-clipboard',
          title: 'JobCardPlannedvsActualProgress',
        },
        component: () => import('@/view/Work-pack/JobCardPlanned/JobPlanned.vue')
      }
    ]
  },

  // Tagged Items 标记项目
  {
    path: '/TaggedItems',
    name: 'TaggedItems',
    meta: {
      icon: 'ios-bookmarks-outline',
      title: 'TaggedItems'
    },
    component: Main,
    children: [
      {
        path: 'TaggedItem',
        name: 'All',
        meta: {
          // icon: 'md-clipboard',
          title: 'All'
        },
        component: () => import('@/view/TaggedItems/All/All.vue')
      },
      {
        path: 'Cable',
        name: 'Cable',
        meta: {
          // icon: 'md-clipboard',
          title: 'Cable'
        },
        component: () => import('@/view/TaggedItems/Cable/Cable.vue')
      },
      {
        path: 'Line',
        name: 'Lines',
        meta: {
          // icon: 'md-clipboard',
          title: 'Line'
        },
        component: () => import('@/view/TaggedItems/Line/Line.vue')
      },
      {
        path: 'MechanicalJoint',
        name: 'MechanicalJoint',
        meta: {
          // icon: 'md-clipboard',
          title: 'MechanicalJoint'
        },
        component: () => import('@/view/TaggedItems/MechanicalJoint/MechanicalJoint.vue')
      },
      {
        path: 'Spool',
        name: 'Spool',
        meta: {
          // icon: 'md-clipboard',
          title: 'Spool'
        },
        component: () => import('@/view/TaggedItems/Spool/Spool.vue')
      },
      {
        path: 'Tag',
        name: 'Tag',
        meta: {
          // icon: 'md-clipboard',
          title: 'Tag'
        },
        component: () => import('@/view/TaggedItems/Tag/Tag.vue')
      },
      {
        path: 'TestPack',
        name: 'TestPack',
        meta: {
          // icon: 'md-clipboard',
          title: 'TestPack'
        },
        component: () => import('@/view/TaggedItems/TestPack/TestPack.vue')
      },
      {
        path: 'TagSet',
        name: 'TagSet',
        meta: {
          // icon: 'md-clipboard',
          title: 'TagSet'
        },
        component: () => import('@/view/TaggedItems/TagSet/TagSet.vue')
      }
    ]
  },

  // Certification模块
  {
    path: '/Certification',
    name: 'Certification',
    meta: {
      icon: 'ios-medal-outline',
      title: 'ITRCheckSheet'
    },
    component: Main,
    children: [
      {
        path: 'TagITRs',
        name: 'TagITRs',
        meta: {
          // icon: 'md-clipboard',
          title: 'TagITRs'
        },
        component: () => import('@/view/Certification/Tag-itr/Tag-itr.vue')

      },
      {
        path: 'TagITRsEditDocument',
        name: 'TagITRsEditDocument',
        meta: {
          title: 'TagITRsEditDocument',
          hideInMenu: true
        },
        component: () => import('@/view/Certification/Tag-itr/TagITRsEditDocument.vue')
      },
      {
        path: 'MultiTagITR',
        name: 'MultiTagITR',
        meta: {
          // icon: 'md-clipboard',
          title: 'MultiTagITR',
          hideInMenu: true,
        },
        component: () => import('@/view/Certification/MultiTagITR/MultiTagITR.vue')
      },
      {
        path: 'EquipmentTypetoITRReview',
        name: 'EquipmentTypetoITRReview',
        meta: {
          // icon: 'md-clipboard',
          title: 'EquipmentTypetoITRReview'
        },
        component: () => import('@/view/Certification/EquipmentTypetoITRReview/EquipmentTypetoITRReview.vue')
      },
      {
        path: 'TagReviewforExAllocation',
        name: 'TagReviewforExAllocation',
        meta: {
          // icon: 'md-clipboard',
          title: 'TagReviewforExAllocation',
          hideInMenu: true
        },
        component: () => import('@/view/Certification/TagReviewforExAllocation/TagReviewforExAllocation.vue')
      },
      {
        path: 'CompletionsGrid',
        name: 'CompletionsGrid',
        meta: {
          // icon: 'md-clipboard',
          title: 'CompletionsGrid'
        },
        component: () => import('@/view/Certification/CompletionsGrid/CompletionsGrid.vue')
      }

    ]
  },
  // Punch List 模块
  {
    path: '/PunchList',
    name: 'PunchLists',
    meta: {
      icon: 'md-list',
      title: 'PunchList',
      // showAlways: true, // 强制显示父菜单
    },
    component: Main,
    children: [
      // {
      //   path: 'PunchList',
      //   name: 'PunchList',
      //   meta: {
      //     // icon: 'md-clipboard',
      //     title: 'PunchList',
      //     // hideInMenu: true
      //   },
      //   component: () => import('@/view/PunchLists/PunchList/PunchList.vue')
      // },
      {
        path: 'PunchListItem',
        name: 'PunchListItem',
        meta: {
          icon: 'md-clipboard',
          title: 'PunchListItem'
        },
        component: () => import('@/view/PunchLists/PunchListItem/PunchListItem.vue')
      }
    ]
  },

  // Handover 模块
  {
    path: '/Certificate',
    name: 'certificate',
    meta: {
      icon: 'md-repeat',
      title: 'Certificates'
    },
    component: Main,
    children: [

      {
        path: 'MCC',
        name: 'MCC',
        meta: {
          // icon: 'md-clipboard',
          title: 'MCC'
        },
        component: () => import('@/view/Handover/MCC/Mcc.vue')
      },
      {
        path: 'CCC',
        name: 'CCC',
        meta: {
          // icon: 'md-clipboard',
          title: 'CCC'
        },
        component: () => import('@/view/Handover/CCC/Ccc.vue')
      },
      {
        path: 'PAC',
        name: 'PAC',
        meta: {
          // icon: 'md-clipboard',
          title: 'PAC',
          hideInMenu: true
        },
        component: () => import('@/view/Handover/PAC/PAC.vue')
      },
      {
        path: 'RFSU',
        name: 'RFSU',
        meta: {
          // icon: 'md-clipboard',
          title: 'RFSU',
          hideInMenu: true
        },
        component: () => import('@/view/Handover/RFSU/RFSU.vue')
      },
      {
        path: 'FAC',
        name: 'FAC',
        meta: {
          // icon: 'md-clipboard',
          title: 'FAC',
          hideInMenu: true
        },
        component: () => import('@/view/Handover/FAC/FAC.vue')
      },

      {
        path: 'raisemcc',
        name: 'RaiseMcc',
        meta: {
          hideInMenu: true
        },
        component: () => import('@/view/Handover/MCC/RaiseMcc.vue')
      },
      {
        path: 'MCCEditDocument',
        name: 'MCCEditDocument',
        meta: {
          hideInMenu: true
        },
        component: () => import('@/view/Handover/MCC/Mcceditdocument.vue')
      },
      {
        path: 'CCCEditDocument',
        name: 'CCCEditDocument',
        meta: {
          hideInMenu: true
        },
        component: () => import('@/view/Handover/CCC/CCCEditDocument.vue')
      },

      {
        path: 'raiserfsu',
        name: 'RaiseRFSU',
        meta: {
          hideInMenu: true
        },
        component: () => import('@/view/Handover/RFSU/Raiserfsu.vue')
      },

      {
        path: 'raiserccc',
        name: 'RaiseCCC',
        meta: {
          hideInMenu: true
        },
        component: () => import('@/view/Handover/CCC/RaiseCcc.vue')
      }
    ]
  },

  // Procedure 模块
  {
    path: '/Procedures',
    name: 'Procedures',
    meta: {
      icon: 'ios-list-box-outline',
      title: 'Procedure'
    },
    component: Main,
    children: [
      {
        path: 'Procedure',
        name: 'Procedure',
        meta: {
          // icon: 'md-clipboard',
          title: 'Procedure'
        },
        component: () => import('@/view/Procedures/Procedure/Procedure.vue')
      },
      {
        path: 'ProcedureSection',
        name: 'ProcedureSection',
        meta: {
          // icon: 'md-clipboard',
          title: 'ProcedureSection'
        },
        component: () => import('@/view/Procedures/ProcedureSection/ProcedureSection.vue')
      },
      {
        path: 'ProcedureStep',
        name: 'ProcedureStep',
        meta: {
          // icon: 'md-clipboard',
          title: 'ProcedureStep'
        },
        component: () => import('@/view/Procedures/ProcedureStep/ProcedureStep.vue')
      },
      {
        path: 'ProcedureSkeleton',
        name: 'ProcedureSkeleton',
        meta: {
          // icon: 'md-clipboard',
          title: 'ProcedureSkeleton'
        },
        component: () => import('@/view/Procedures/ProcedureSkeleton/ProcedureSkeleton.vue')
      },
      {
        path: 'ProcedureSkeletonSection',
        name: 'ProcedureSkeletonSection',
        meta: {
          // icon: 'md-clipboard',
          title: 'ProcedureSkeletonSection'
        },
        component: () => import('@/view/Procedures/ProcedureSkeletonSection/ProcedureSkeletonSection.vue')
      },
      {
        path: 'ProcedureSkeletonStep',
        name: 'ProcedureSkeletonStep',
        meta: {
          // icon: 'md-clipboard',
          title: 'ProcedureSkeletonStep'
        },
        component: () => import('@/view/Procedures/ProcedureSkeletonStep/ProcedureSkeletonStep.vue')
      }
    ]
  },
  // Changes模块
  {
    path: '/Changes',
    name: 'Changes',
    meta: {
      icon: 'ios-refresh-circle-outline',
      title: 'Changes'
    },
    component: Main,
    children: [
      {
        path: 'MOCs',
        name: 'MOCs',
        meta: {
          // icon: 'md-clipboard',
          title: 'MOCs'
        },
        component: () => import('@/view/Changes/MOCs/MOCs.vue')
      },
      {
        path: 'MOCType',
        name: 'MOCType',
        meta: {
          // icon: 'md-clipboard',
          title: 'MOCType'
        },
        component: () => import('@/view/RefTable/MOCtype/MOCtype.vue')
      },
      {
        path: 'MOCStatus',
        name: 'MOCStatus',
        meta: {
          // icon: 'md-clipboard',
          title: 'MOCStatus'
        },
        component: () => import('@/view/RefTable/MOCstatus/MOCstatus.vue')
      }

    ]
  },

  // Preservation 模块
  {
    path: '/Preservation',
    name: 'Preservation',
    meta: {
      icon: 'ios-lock-outline',
      title: 'Preservation'
    },
    component: Main,
    children: [
      {
        path: 'TagPWL',
        name: 'TagPWL',
        meta: {
          // icon: 'md-clipboard',
          title: 'TagPWL'
        },
        component: () => import('@/view/Preservation/TagPWL/TagPWL.vue')
      },
      {
        path: 'TagPWLsEditDocument',
        name: 'TagPWLsEditDocument',
        meta: {
          title: 'TagPWLsEditDocument',
          hideInMenu: true
        },
        component: () => import('@/view/Preservation/TagPWL/TagPWLsEditDocument.vue')
      },
      {
        path: 'LookAhead',
        name: 'LookAhead',
        meta: {
          // icon: 'md-clipboard',
          title: 'LookAhead'
        },
        component: () => import('@/view/Preservation/LookAhead/LookAhead.vue')
      },
      {
        path: 'EquipmentTypetoPWLReview',
        name: 'EquipmentTypetoPWLReview',
        meta: {
          // icon: 'md-clipboard',
          title: 'EquipmentTypetoPWLReview'
        },
        component: () => import('@/view/Preservation/EquipmentTypetoPWLReview/EquipmentTypetoPWLReview.vue')
      }
    ]
  },

  // Documents 模块
  {
    path: '/Documents',
    name: 'Documents',
    meta: {
      icon: 'md-filing',
      title: 'Document'
    },
    component: Main,
    children: [
      {
        path: 'AsBuiltDrawing',
        name: 'AsBuiltDrawing',
        meta: {
          // icon: 'md-clipboard',
          title: 'AsBuiltDrawing'
        },
        component: () => import('@/view/Documents/AsBuiltDrawing/AsBuiltDrawing.vue')
      },
      {
        path: 'Attachment',
        name: 'Attachment',
        meta: {
          // icon: 'md-clipboard',
          title: 'Attachment'
        },
        component: () => import('@/view/Documents/Attachment/Attachment.vue')
      },
      {
        path: 'Document',
        name: 'Document',
        meta: {
          // icon: 'md-clipboard',
          title: 'OtherDocument'
        },
        component: () => import('@/view/Documents/Document/Document.vue')
      }
    ]
  },

  // Operation Readiness & Assurance
  {
    path: '/OperationReadinessAssurance',
    name: 'OperationReadinessAssurance',
    meta: {
      icon: 'ios-list',
      title: 'OperationReadinessAssurance'
    },
    component: Main,
    children: [
      {
        path: 'OperationsReadiness',
        name: 'OperationsReadiness',
        meta: {
          // icon: 'md-clipboard',
          title: 'OperationsReadiness'
        },
        component: () => import('@/view/ORA/OperationsReadiness/OperationsReadiness.vue'),
      },
      {
        path: 'TechnicalIntegritySafetyReadiness',
        name: 'TechnicalIntegritySafetyReadiness',
        meta: {
          // icon: 'md-clipboard',
          title: 'TechnicalIntegritySafetyReadiness'
        },
        component: () => import('@/view/ORA/TechnicalIntegritySafetyReadiness/TechnicalIntegritySafetyReadiness.vue'),
      },
      {
        path: 'ReliabilityMaintenanceReadiness',
        name: 'ReliabilityMaintenanceReadiness',
        meta: {
          // icon: 'md-clipboard',
          title: 'ReliabilityMaintenanceReadiness'
        },
        component: () => import('@/view/ORA/ReliabilityMaintenanceReadiness/ReliabilityMaintenanceReadiness.vue'),
      },
      {
        path: 'InformationManagementReadiness',
        name: 'InformationManagementReadiness',
        meta: {
          // icon: 'md-clipboard',
          title: 'InformationManagementReadiness'
        },
        component: () => import('@/view/ORA/InformationManagementReadiness/InformationManagementReadiness.vue'),
      },
      {
        path: 'HSSEReadiness',
        name: 'HSSEReadiness',
        meta: {
          // icon: 'md-clipboard',
          title: 'HSSEReadiness'
        },
        component: () => import('@/view/ORA/HSSEReadiness/HSSEReadiness.vue'),
      },
      {
        path: 'SupplyChainReadinessLogistics',
        name: 'SupplyChainReadinessLogistics',
        meta: {
          // icon: 'md-clipboard',
          title: 'SupplyChainReadinessLogistics'
        },
        component: () => import('@/view/ORA/SupplyChainReadinessLogistics/SupplyChainReadinessLogistics.vue'),
      },
    ]
  },

  // Report 模块
  {
    path: '/Report',
    name: 'Report',
    meta: {
      icon: 'ios-people-outline',
      title: 'Report'
    },
    component: Main,
    children: [
      {
        path: 'ReportList',
        name: 'ReportList',
        meta: {
          // icon: 'md-clipboard',
          title: 'ReportList'
        },
        component: () => import('@/view/Report/ReportList/ReportList.vue')
      },
      {
        path: 'PlannedVsActualProgress',
        name: 'PlannedVsActualProgress',
        meta: {
          // icon: 'md-clipboard',
          title: 'PlannedVsActualProgress'
        },
        component: () => import('@/view/Report/PlannedVsActualProgress/PlannedVsActualProgress.vue')
      },
      {
        path: 'Skyline',
        name: 'Skyline',
        meta: {
          // icon: 'md-clipboard',
          title: 'Skyline'
        },
        component: () => import('@/view/Report/Skyline/Skyline.vue')
      },
      {
        path: 'ScheduledReport',
        name: 'ScheduledReport',
        meta: {
          // icon: 'md-clipboard',
          title: 'ScheduledReport',
          hideInMenu: true
        },
        component: () => import('@/view/Report/ScheduledReport/ScheduledReport.vue')
      },
      {
        path: 'ScheduledReportHistoryList',
        name: 'ScheduledReportHistoryList',
        meta: {
          // icon: 'md-clipboard',
          title: 'ScheduledReportHistoryList',
          hideInMenu: true
        },
        component: () => import('@/view/Report/ScheduledReportHistoryList/ScheduledReportHistoryList.vue')
      },
      {
        path: 'FilterReport',
        name: 'filterReport',
        meta: {
          // icon: 'md-clipboard',
          title: 'FilterReport',
          hideInMenu: true
        },
        component: () => import('@/view/Report/ReportList/FilterReport.vue')
      },
      {
        path: 'CreateNewDetailtedReort',
        name: 'createNewDetailtedReort',
        meta: {
          // icon: 'md-clipboard',
          title: 'CreateNewDetailtedReort',
          hideInMenu: true
        },
        component: () => import('@/view/Report/CreateNewDetailtedReort/CreateNewDetailtedReort.vue')
      },
      {
        path: 'CreateNewSummaryReport',
        name: 'CreateNewSummaryReport',
        meta: {
          // icon: 'md-clipboard',
          title: 'CreateNewSummaryReport',
          hideInMenu: true
        },
        component: () => import('@/view/Report/CreateNewSummaryReport/CreateNewSummaryReport.vue')
      },
      {
        path: 'CustomReportList',
        name: 'CustomReportList',
        meta: {
          // icon: 'md-clipboard',
          title: 'CustomReportList',
          hideInMenu: true
        },
        component: () => import('@/view/Report/CustomReportList/CustomReportList.vue')
      },
      {
        path: 'FiletersCustomReport',
        name: 'FiletersCustomReport',
        meta: {
          // icon: 'md-clipboard',
          title: 'FiletersCustomReport',
          hideInMenu: true
        },
        component: () => import('@/view/Report/CustomReportList/FiletersCustomReport.vue')
      }
    ]
  },

  // Admin 模块
  {
    path: '/Admin',
    name: 'Admin',
    meta: {
      icon: 'md-funnel',
      title: 'Admin',
    },
    component: Main,
    children: [
      {
        path: 'LevelSelect',
        name: 'LevelSelect',
        meta: {
          // icon: 'md-clipboard',
          title: 'LevelSelect',
          hideInMenu: true
        },
        component: () => import('@/view/Admin/LevelSelect/LevelSelect.vue')
      },
      {
        path: 'LevelA',
        name: 'LevelA',
        meta: {
          // icon: 'md-clipboard',
          title: 'LevelA'
        },
        component: () => import('@/view/Admin/LevelA/LevelA.vue')
      },
      {
        path: 'LevelASelection',
        name: 'LevelASelection',
        meta: {
          // icon: 'md-clipboard',
          title: 'LevelASelection',
          hideInMenu: true
        },
        component: () => import('@/view/Admin/LevelASelection/LevelASelection.vue')
      },
      {
        path: 'LevelB',
        name: 'LevelB',
        meta: {
          // icon: 'md-clipboard',
          title: 'LevelB'
        },
        component: () => import('@/view/Admin/LevelB/LevelB.vue')
      },
      {
        path: 'LevelBSelection',
        name: 'LevelBSelection',
        props: true, // 将路由参数作为 props 传递给组件
        meta: {
          // icon: 'md-clipboard',
          title: 'LevelBSelection',
          hideInMenu: true
        },
        component: () => import('@/view/Admin/LevelBSelection/LevelBSelection.vue')
      },
      {
        path: 'LevelC',
        name: 'LevelC',
        meta: {
          // icon: 'md-clipboard',
          title: 'LevelC'
        },
        component: () => import('@/view/Admin/LevelC/LevelC.vue')
      },
      {
        path: 'LevelD',
        name: 'LevelD',
        meta: {
          // icon: 'md-clipboard',
          title: 'LevelD'
        },
        component: () => import('@/view/Admin/LevelD/LevelD.vue')
      },
      {
        path: 'LevelE',
        name: 'LevelE',
        meta: {
          // icon: 'md-clipboard',
          title: 'LevelE'
        },
        component: () => import('@/view/Admin/LevelE/LevelE.vue')
      },
      {
        path: 'Defaultsginoffs',
        name: 'Defaultsginoffs',
        meta: {
          // icon: 'md-clipboard',
          title: 'Defaultsginoffs'
        },
        component: () => import('@/view/Admin/Defaultsginoffs/Defaultsginoffs.vue')
      },
      {
        path: 'SavedSearches',
        name: 'SavedSearches',
        meta: {
          // icon: 'md-clipboard',
          title: 'SavedSearches',
          hideInMenu: true
        },
        component: () => import('@/view/Admin/SavedSearches/SavedSearche.vue')
      },

      {
        path: 'Notice',
        name: 'Notice',
        meta: {
          // icon: 'md-clipboard',
          title: 'Notice',
          hideInMenu: true
        },
        component: () => import('@/view/Admin/Notice/Notice.vue')
      },
    ]
  },

  // To do list 待办模块
  {
    path: '/TodoList',
    name: 'TodoList',
    meta: {
      title: 'ToDoList',
      hideInMenu: true,
    },
    component: Main,
    children: [
      {
        path: 'todolist',
        name: 'todolist',
        meta: {
          title: 'ToDoList',
          hideInMenu: true,
          hideInBread: true
        },
        component: () => import('@/view/TodoList/todolist.vue')
      }
    ]
  },

  // System Settings 模块
  {
    path: '/SystemSettings',
    name: 'SystemSettings',
    meta: {
      icon: 'md-options',
      title: 'SystemSettings',
      hideInMenu: true,
    },
    component: Main,
    children: [
      {
        path: 'Workbenches',
        name: 'Workbenches',
        meta: {
          title: 'Workbenches'

        },
        component: () => import('@/view/Workbenches/Workbenches.vue')
      },
      {
        path: '/SelectPorject',
        name: 'SelectPorject',
        meta: {
          title: 'SelectPorject',
          hideInMenu: true,
          hideInBread: true
        },
        component: () => import('@/view/SelectPorject/SelectPorject.vue')
      },

      {
        path: 'User',
        name: 'User',
        meta: {
          // icon: 'md-clipboard',
          title: 'User',
          label: 'User'
        },
        component: () => import('@/view/SystemSettings/User/User.vue')
      },
      {
        path: 'Usercenter',
        name: 'Usercenter',
        meta: {
          title: 'UserCenter',
          label: 'Usercenter'
        },
        component: () => import('@/view/SystemSettings/Usercenter/Usercenter.vue')
      },
      {
        path: 'Menu',
        name: 'Menu',
        meta: {
          // icon: 'md-clipboard',
          title: 'menumanagement'
        },
        component: () => import('@/view/SystemSettings/Menu/Menu.vue')
      },
      {
        path: 'Role',
        name: 'Role',
        meta: {
          // icon: 'md-clipboard',
          title: 'Role'
        },
        component: () => import('@/view/SystemSettings/Role/Role.vue')
      },
      {
        path: 'PermissionManagement',
        name: 'PermissionManagement',
        meta: {
          // icon: 'md-clipboard',
          title: 'PermissionManagement'
        },
        component: () => import('@/view/SystemSettings/PermissionManagement/PermissionManagement.vue')
      },
      {
        path: 'Accountlist',
        name: 'Accountlist',
        meta: {
          // icon: 'md-clipboard',
          title: 'Accountlist'
        },
        component: () => import('@/view/SystemSettings/Accountlist/Accountlist.vue')
      },
      {

        path: '/assign-user',
        name: 'AssignUser',
        meta: {
          // hideInMenu: true
        },
        component: () => import('@/view/SystemSettings/Assignuser/Assignuser.vue')
      }

    ]
  },

  {
    path: '/401',
    name: 'error_401',
    meta: {
      hideInMenu: true
    },
    component: () => import('@/view/error-page/401.vue')
  },
  {
    path: '/500',
    name: 'error_500',
    meta: {
      hideInMenu: true
    },
    component: () => import('@/view/error-page/500.vue')
  }
  // {
  //   path: '*',
  //   name: 'error_404',
  //   meta: {
  //     hideInMenu: true
  //   },
  //   component: () => import('@/view/error-page/404.vue')
  // },

]
